/**
 * Status badge derivation for a queued job row — replaces the legacy
 * colored material-icons dot (QueueJobToStatus) with a Badge, same
 * convention as OrganizationsPage/organizationStatus.js. Precedence
 * mirrors the original exactly: failed and completed are terminal states
 * checked before the in-progress ("fetched") one.
 *
 * @param {Object} job
 * @param {boolean} job.fetched
 * @param {boolean} job.failed
 * @param {boolean} job.completed
 * @returns {{color: 'gray'|'brand'|'success'|'error', label: string}}
 */
export function getJobStatus({ fetched, failed, completed }) {
  if (failed) {
    return { color: "error", label: "Failed" };
  }

  if (completed) {
    return { color: "success", label: "Completed" };
  }

  if (fetched) {
    return { color: "brand", label: "Syncing" };
  }

  return { color: "gray", label: "Queued" };
}
